export default {"src":"/_next/static/media/rascoda_logo.9551205b.svg","height":25,"width":126,"blurWidth":0,"blurHeight":0};